import React, { forwardRef } from "react";

import { cn } from "@shared/utils/cn";

import { MinimalFormField, Resolver } from "../types/form-fields";
import { InputTextOptions } from "./input-text";

export interface InputTextareaProps extends MinimalFormField<string> {
  type: "textarea";
  className?: string;
  options?: Pick<InputTextOptions, "placeholder" | "className">;
}

export const InputTextarea = forwardRef<
  HTMLTextAreaElement,
  InputTextareaProps
>(({ label, error, onChange, className, options = {}, ...props }, ref) => (
  <div className="flex flex-col transition-colors">
    {label && (
      <label
        htmlFor=""
        className={cn(
          "block text-black/80 font-poppins text-sm font-medium mb-3.5",
          error && "text-red"
        )}
      >
        {label}
      </label>
    )}
    <textarea
      className={cn(
        "text-black/80 font-inter w-full py-[9px] px-[13px] focus:outline-none rounded-lg border border-black/20",
        error && "border-red",
        className,
        options?.className
      )}
      ref={ref}
      onChange={(e) => onChange(e.target.value)}
      placeholder={options?.placeholder}
      {...props}
    />
    {error && <p className="text-red text-xs italic mt-1">{error}</p>}
  </div>
));

InputTextarea.displayName = "InputTextarea";

export const inputTextareaResolver: Resolver<InputTextareaProps> = {
  type: "textarea",
  component: InputTextarea,
  defaultValue: "",
};
